<template>
  <div
    :class="$style.mdmCertDetails"
  >
    <p
      :class="$style.configurationBlurb"
    >
      Enroll a company-owned Apple iOS device in MDM
      by clicking "View QR Code" and following the prompts
      to enroll the device in MDM. The enrolled iOS device
      is visible in the Admin Portal. Deliver the device to the
      user and the user can immediately access company resources,
      such as email, calendar, contacts, and documents.
    </p>
    <FlatActionButton
      :action="handleEnrollmentProfile"
      :buttonClass="[$style.qrCodeButton]"
      text="View QR Code"
    />
    <AlertContainer>
      <Alert
        v-if="errorText"
        type="error"
      >
        <span>{{ errorText }}</span>
      </Alert>
    </AlertContainer>
  </div>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { isEmpty } from 'lodash';
import { mapActions, mapState } from 'vuex';
import Alert from 'client/components/Alert/Alert.vue';
import AlertContainer from 'client/components/Alert/AlertContainer.vue';
import FlatActionButton from 'components/Buttons/FlatActionButton.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';
import QRCodeModal from 'client/components/Modal/ModalComponents/QRCodeModal.vue';

const mdmSettingsModel = StoreModelMap[ItemTypeConsts.mdmSettings];
const systemModel = StoreModelMap[ItemTypeConsts.device];

export default {
  name: 'MdmAdminIOSConfiguration',

  components: {
    Alert,
    AlertContainer,
    FlatActionButton,
  },
  ModalEventBus,
  data() {
    return {
      errorText: '',
      qrLink: '',
    };
  },

  computed: {
    ...mapState(
      systemModel, [
        'item',
      ],
    ),
    formattedLink() {
      return `${this.qrLink.slice(0, 47)}...`;
    },
  },

  mounted() {
    this.fetchMdmSettings();
  },

  methods: {
    ...mapActions(mdmSettingsModel, [
      'fetchMdmSettings',
      'fetchEnrollmentProfileDownloadUrl',
    ]),

    async handleEnrollmentProfile() {
      await this.retreiveEnrollmentProfileDownloadUrl();

      if (isEmpty(this.errorText)) {
        this.showQRCodeModal();
      }
    },

    async retreiveEnrollmentProfileDownloadUrl() {
      try {
        const response = await this.fetchEnrollmentProfileDownloadUrl();
        this.qrLink = response.download_url;
      } catch {
        this.errorText = 'The service encountered a temporary error and could not retrieve the enrollment profile download URL. Please try again later.';
      }
    },

    showQRCodeModal() {
      this.$options.ModalEventBus.open({
        component: QRCodeModal,
        componentProps: {
          qrLink: this.qrLink,
        },
        isLargeModal: true,
      });
    },
  },
};
</script>

<style module>
@value (jcPrimary, jcGrey100) from '~css/brand-colors.css';

.configurationBlurb {
  padding-top: 10px;
}

.mdmCertDetails {
  border-top: 1px solid jcGrey100;
}

.mdmCertDetails .qrCodeButton {
  background-color: jcPrimary;
  color: black;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1rem;
}
</style>
